import type { FetchError } from 'ofetch'
import type { Ref } from 'vue'
import { isDefined } from '@vueuse/core'
import { consola } from 'consola'

export function assertDefined<T>(
  target: Ref<T | undefined>,
  error: Ref<FetchError<any> | null>,
): asserts target is Ref<NonNullable<T>> {
  if (!isDefined(target) && error.value) {
    if (!environment('production')) {
      consola.error(error.value)
    }
    throw createError({
      ...error.value,
      fatal: error.value?.statusCode === 404,
    })
  }
}
